export const detectCountry = async () => {
  const COUNTRY_CACHE_KEY = "user_country";

  // Check if country is already cached
  const cachedCountry = localStorage.getItem(COUNTRY_CACHE_KEY);
  if (cachedCountry) {
    return cachedCountry;
  }

  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();

    let detectedCountry = "US"; // Default to US

    if (data && data.country) {
      if (data.country === "US") {
        detectedCountry = "US";
      } else if (data.country === "CA") {
        detectedCountry = "CA";
      }
    }
    localStorage.setItem(COUNTRY_CACHE_KEY, detectedCountry);
    return detectedCountry;
  } catch (error) {
    console.error("Failed to detect country:", error);

    return "US";
  }
};

export const SCRIBEPHONE_CONSENT_MODES = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL",
};
